import ApiService from "../../services/ApiService";

export const fetchSingleSurveyAnswer = (userId: string, timestamp: string, setSurveyData: Function) => {
  ApiService.get(`surveys/answers/${userId}/${timestamp}`)
    .then((resp) => setSurveyData({ data: resp.data?.survey_answer, loading: false }))
    .catch((error) => console.error("Error fetching user survey", error))
    .finally(() => setSurveyData((prev: any) => ({ ...prev, loading: false })));
};
